export default {"src":"/_next/static/media/omnipresent.332f3662.svg","height":24,"width":130,"blurWidth":0,"blurHeight":0};